import React, {Suspense, Component} from 'react';
import axios from 'axios';
import moment from 'moment';
import { Route, Switch } from 'react-router-dom';
import { ApiService, getUserName } from '../../services/ApiService1';
import { getAccessToken, getIsSSO, getSSOEnabled } from '../../services/constants';
import { connect } from 'react-redux';
import MainWrapper from './MainWrapper';
import MainContainer from './MainContainer';
import LogIn from '../LogIn';
import {message} from "antd";
import { setAuthDetails } from '../../redux/actions/authAction';
import { setLocalData } from '../../redux/actions/localDataActions';
import Cookies from "universal-cookie";
import Register from "../Register/Register";

const cookies = new Cookies();

class Router extends Component {

  constructor() {
    super();
    this.state = {
      loading: false,
      isLoading: false,
      configData: {},
      isValidClient: cookies.get('JWT_ACCESSTOKEN'),
      accessToken: cookies.get('JWT_ACCESSTOKEN'),
    };
  }

  async componentWillMount() {
    console.log('getIsSSOgetIsSSO', getIsSSO())
    console.log('getSSOEnabled', getSSOEnabled())
    this.props.setLocalData(this.props.configProps)
  }

  async componentDidMount() {
    const { configProps = {}, match: { params: { clientId = '' } = {} } = {} } = this.props

    const currentClientId = clientId;

    if (!getAccessToken() && !configProps.isSSO) {
      return this.props.history.push(`/${currentClientId}/login`);
    } else if (!getAccessToken() && configProps.isSSO) {
      window.location.replace(configProps.SSORedirectURL)
    }

    const { sessionTimeOut } = this.props
    const getTime = localStorage.getItem('timestamp')
    const expiredTime = sessionTimeOut * 60
    const remainingTime = moment().unix() - getTime

    if(sessionTimeOut && remainingTime > expiredTime) {
      // localStorage.clear()
      // this.props.history.push(`/${currentClientId}/login`);
    }
  }

  render() {
    const {isLoading, isValidClient, accessToken} = this.state;

    if (isLoading) {
      return (
        <div className={`load`}>
          <div className="load__icon-wrap">
            <svg className="load__icon">
              <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
            </svg>
          </div>
        </div>
      );
    }

    // if (!getAccessToken()) {
    //   return <h1>Tenant is not valid!</h1>
    // }

    return (
      <MainWrapper>
        <main>
          <Switch>
            <Route path="/:clientId/callback" component={Register}/>
            <Route path="/:clientId/login" component={LogIn}/>
            {
              getAccessToken() && <Route path="/:clientId" render={(props) => <MainContainer configProps={this.state.configProps} {...props} />}/>
            }
          </Switch>
        </main>
      </MainWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  sessionTimeOut: ((state || {}).local || {}).SessionTimeOut || localStorage.getItem('SESSION_TIMEOUT') || 0
});

const mapDispatchToProps = (dispatch) => ({
  setAuthDetails: (state) => {
    return dispatch(setAuthDetails(state))
  },
  setLocalData: (state) => {
    return dispatch(setLocalData(state))
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Router)

